import {
  ActivityLog,
  activityLogService,
  ActivityLogsResponse,
} from "@/services/activityLogService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActivityLogState {
  logs: ActivityLog[];
  pagination: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    itemsPerPage: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: ActivityLogState = {
  logs: [],
  pagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    itemsPerPage: 20,
  },
  loading: false,
  error: null,
};

export const fetchActivityLogs = createAsyncThunk(
  "activityLogs/fetch",
  async ({ page, limit }: { page: number; limit: number }) => {
    const response = await activityLogService.getActivityLogs({ page, limit });
    return response;
  },
);

const activityLogSlice = createSlice({
  name: "activityLogs",
  initialState,
  reducers: {
    clearActivityLogs: (state) => {
      state.logs = [];
      state.pagination = initialState.pagination;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchActivityLogs.fulfilled,
        (state, action: PayloadAction<ActivityLogsResponse>) => {
          state.loading = false;
          state.logs = action.payload.logs;
          state.pagination = action.payload.pagination;
        },
      )
      .addCase(fetchActivityLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch activity logs";
      });
  },
});

export const { clearActivityLogs } = activityLogSlice.actions;
export default activityLogSlice.reducer;
